/**
 * ISSUE-1355. The round mark for a chat in the Messages list and in the
 * conversation header: the chat's photo when one resolved, otherwise an
 * initials plate built from the title.
 *
 * The plate color comes from `avatarPlateStyle`, hashed on the title. A
 * private chat's title is the other fan's name, so their plate here matches
 * the plate beside their messages and in the members list (ISSUE-1111).
 */
import type { ReactNode } from "react";

import { avatarPlateStyle } from "../profile/avatarPlateStyle";
import { initialsFromTitle } from "./chatDisplay";

export type typeChatAvatarSize = "sm" | "md";

const SIZE_CLASS: Record<typeChatAvatarSize, string> = {
  sm: "h-8 w-8 text-caption",
  md: "h-10 w-10 text-caption",
};

export const ChatAvatar = ({
  title,
  photoUrl,
  size = "md",
  testId,
}: {
  title: string;
  photoUrl: string | null;
  size?: typeChatAvatarSize | undefined;
  testId?: string | undefined;
}): ReactNode => {
  const sizeClass = SIZE_CLASS[size];
  if (photoUrl !== null && photoUrl !== "") {
    return (
      <img
        src={photoUrl}
        alt=""
        data-testid={testId}
        data-avatar-kind="photo"
        className={`${sizeClass} shrink-0 rounded-full object-cover`}
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      data-testid={testId}
      data-avatar-kind="initials"
      className={`${sizeClass} flex shrink-0 items-center justify-center rounded-full`}
      style={avatarPlateStyle(title)}
    >
      {initialsFromTitle(title)}
    </span>
  );
};
